import FormattedMessage from '../../../config/components/TranslationWrapper';
import globalMessages from '../../../config/globalMessages';
import BackupIcon from '@mui/icons-material/Backup';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';

const sidebarConfig = {
  inflateCycle: true,
  modalroutes: ['modal-orders-queue', 'modal-jd-queue', 'modal-material-needed', 'modal-packages-queue', 'modal-incoming-packages-queue', 'modal-created-packages-queue'],
  sidebar: [
    {
      _tag: 'CSidebarNavItem',
      name: <FormattedMessage {...globalMessages.productionline} />,
      to: '/dashboard',
      icon: 'cilSettings'
    },
    {
      _tag: 'CSidebarNavDropdown',
      name: <FormattedMessage {...globalMessages.productionstatus} identifier={'productionstatus'} />,
      to: '',
      icon: 'cilShareBoxed',
      _children: [
        {
          _tag: 'CSidebarNavItem',
          id: 'modal-orders-queue',
          name: <FormattedMessage {...globalMessages.ordersQueueTitle} identifier={'ordersQueueTitle'} />,
          to: ''
        },
        {
          _tag: 'CSidebarNavItem',
          id: 'modal-jd-queue',
          name: <FormattedMessage {...globalMessages.jdQueueTitle} identifier={'jdQueueTitle'} />,
          to: ''
        },
        {
          _tag: 'CSidebarNavItem',
          id: 'modal-material-needed',
          name: <FormattedMessage {...globalMessages.materialNeededTitle} identifier={'materialNeededTitle'} />,
          to: ''
        },
        {
          _tag: 'CSidebarNavItem',
          id: 'modal-packages-queue',
          name: <FormattedMessage {...globalMessages.packagesQueueTitle} identifier={'packagesQueueTitle'} />,
          to: ''
        },
        {
          _tag: 'CSidebarNavItem',
          id: 'modal-incoming-packages-queue',
          name: <FormattedMessage {...globalMessages.incomingPackagesQueueTitle} identifier={'incomingPackagesQueueTitle'} />,
          to: ''
        },
        {
          _tag: 'CSidebarNavItem',
          id: 'modal-created-packages-queue',
          name: <FormattedMessage {...globalMessages.createdPackagesQueueTitle} identifier={'createdPackagesQueueTitle'} />,
          to: ''
        }
      ]
    },
    {
      _tag: 'CSidebarNavDropdown',
      name: <FormattedMessage {...globalMessages.maschines} identifier={'maschines'} />,
      route: '/machines',
      icon: 'cilLayers',
      superAdmin: true,
      _children: [
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.loader} identifier={'loader'} />,
          to: '/loader'
        },
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.storage} identifier={'storage'} />,
          to: '/storage'
        },
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.zinc} identifier={'zinc'} />,
          to: '/zinc'
        }
      ]
    },
    {
      _tag: 'CSidebarNavDropdown',
      name: <FormattedMessage {...globalMessages.bsh} identifier={'bsh'} />,
      route: '/bsh',
      icon: 'cilTask',
      _children: [
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.todo} identifier={'todo'} />,
          to: '/bsh/todo',
          key: 'todo'
        },
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.producing} identifier={'producing'} />,
          to: '/bsh/producing'
        },
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.done} identifier={'done'} />,
          to: '/bsh/done'
        },
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.deleted} identifier={'deleted'} />,
          to: '/bsh/deleted'
        }
      ]
    },
    {
      _tag: 'CSidebarNavDropdown',
      name: <FormattedMessage {...globalMessages.packages} identifier={'packages'} />,
      route: '/packages/',
      icon: 'cilAlignRight',
      _children: [
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.incoming} identifier={'incoming'} />,
          to: '/packages/incoming'
        },
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.created} identifier={'created'} />,
          to: '/packages/sorted'
        }
      ]
    },
    {
      _tag: 'CSidebarNavItem',
      name: <FormattedMessage {...globalMessages.eventlog} identifier={'eventlog'} />,
      to: '/eventlog/events',
      icon: 'cilSpreadsheet'
    },
    {
      _tag: 'CSidebarNavItem',
      name: <FormattedMessage {...globalMessages.vnc} identifier={'vnc'} />,
      to: '/vnc',
      icon: 'cilSpreadsheet'
    },
    {
      _tag: 'CSidebarNavItem',
      name: <FormattedMessage {...globalMessages.camera} identifier={'camera'} />,
      to: '/camera',
      icon: 'cilVideo'
    },
    {
      _tag: 'CSidebarNavItem',
      name: <FormattedMessage {...globalMessages.terminal} identifier={'terminal'} />,
      to: '/terminal',
      icon: 'cilTerminal'
    },
    {
      _tag: 'CSidebarNavItem',
      name: <FormattedMessage {...globalMessages.files} />,
      to: '/files',
      icon: 'cilBookmark'
    },
     {
      _tag: 'CSidebarNavDropdown',
      name: <FormattedMessage {...globalMessages.statistics} identifier={'statistics'} />,
      route: '/files/',
      icon: 'cilAlignRight',
      _children: [
        {
          _tag: 'CSidebarNavItem',
          name: <FormattedMessage {...globalMessages.goldeneye} identifier={'goldeneye'} />,
          to: '/goldeneye',
          icon: 'cilSpreadsheet'
        }
        // {
        //   _tag: 'CSidebarNavItem',
        //   name: <FormattedMessage {...globalMessages.gluebook} identifier={'gluebook'} />,
        //   to: '/gluebook',
        //   icon: 'cilSpreadsheet'
        // },
      ]
    },
    {
      _tag: 'CSidebarNavItem',
      name: <FormattedMessage {...globalMessages.users} />,
      to: '/users',
      icon: 'cilUser',
      superMegaAdmin: true
    },
    {
      _tag: 'CSidebarNavItem',
      name: 'Change Password',
      to: '/changePassword',
      icon: 'cilSettings',
      superAdmin: true
    },
    {
      _tag: 'CSidebarNavItem',
      name: <FormattedMessage {...globalMessages.IBA} identifier={'IBA'} />,
      to: '/IBA',
      icon: 'cilSpreadsheet',
      superMegaAdmin: true
    },
    {
      _tag: 'CSidebarNavItem',
      name: 'Chat History',
      to: '/chatHistory',
      icon: 'cilSpreadsheet',
      superMegaAdmin: true
    },
    {
      _tag: 'CSidebarNavDivider'
    }
  ],
  indicatorItems: [
    {
      ident: 'backend',
      message: globalMessages.indicatorBackend,
      active: false,
      icon: <BackupIcon />
    },
    {
      ident: 'control',
      message: globalMessages.indicatorControl,
      active: false,
      icon: <SettingsRemoteIcon />,
      statusSource: 'merged',
      staleAfterMs: 10000,
      hover: {
        controls: [
          { id: 'WIEHAG-GLT', label: 'GLT' },
          { id: 'WIEHAG-SORT', label: 'SORT' }
        ],
        metrics: ['merge_ms', 'merge_cpu_ms', 'phase_load_previous_ms', 'phase_publish_redis_ms', 'snapshot_bytes', 'changed_hashes'],
        minPrivilege: 4,
        historyPath: '/mergeStatistics'
      }
    }
  ],
  statusItem: [],
  multiControlConfig: true,
  multiControlOptions: [
    { identifier: 'ALL', processIdentifier: '', merged: true },
    { identifier: 'GLT', processIdentifier: 'WIEHAG-GLT', merged: false },
    { identifier: 'SORT', processIdentifier: 'WIEHAG-SORT', merged: false }
  ],
  archiveIntervalStep: 1000 // in miliseconds
};

export default sidebarConfig;
